import { flatArrayToString } from "@utils";
import axiosClient from "./axiosClient";

export const weeklyScheduleApi = {
    // getListWorksInConstruction: (params: any, arrayGroupId: any, sort_value: any) => {
    //     let url = `api/get-weekly-schedule-by-month?year=${params.year}&month=${params.month}&limit=${params.limit}&page=${params.page}&sort_value=${sort_value}`;
    //     if (arrayGroupId?.length) {
    //         url += flatArrayToString("groupId", arrayGroupId);
    //     }
    //     return axiosClient.get(url);
    // },
    getListWorksInConstruction: (params: any, arrayGroupId: any, sort_value: any, user_id: any) => {
        let url = `api/get-weekly-schedule-by-month?year=${params.year || ""}&month=${params.month || ""}&limit=${params.limit || ""}&page=${params.page || ""}`;
        if (sort_value) {
            url += `&sort_value=${sort_value}`;
        }
        if (user_id) {
            url += `&user_id=${user_id}`;
        }
        if (arrayGroupId?.length) {
            url += flatArrayToString("groupId", arrayGroupId);
        }
        return axiosClient.get(url);
    },
    createNoteWeeklySchedule: (body) => {
        const url = "api/create-weekly-schedule";
        return axiosClient.post(url, body);
    },
    updateOrderListName: (params: any) => {
        const url = `api/change-user-position`;

        // Try to cast to number
        const numericValue = Number(params);
        const isNumeric = !isNaN(numericValue);

        const payload = {
            user_id: isNumeric ? numericValue : params
        };

        return axiosClient.post(url, payload);
    },
    updateGroupOrder: (groupId: number | string) => {
        const url = `api/change-group-position`;
        // Try to cast to number
        const numericValue = Number(groupId);
        const isNumeric = !isNaN(numericValue);

        const payload = {
            group_id: isNumeric ? numericValue : groupId
        };

        return axiosClient.post(url, payload);
    },
    updateContractorOrder: (params: any) => {
        const url = `api/change-contractor-position`;
        let payload;

        // Check if params is an object, if so don't change it
        if (typeof params === 'object' && params !== null && !Array.isArray(params)) {
            payload = params;
        } else {
            // Try to cast to number
            const numericValue = Number(params);
            const isNumeric = !isNaN(numericValue);

            payload = {
                contractor_id: isNumeric ? numericValue : params
            };
        }
        return axiosClient.post(url, payload);
    },
    updateConstructionSiteOrder: (params: any) => {
        const url = `api/change-construction-site-position`;
        let payload;

        // Check if params is an object, if so don't change it
        if (typeof params === 'object' && params !== null && !Array.isArray(params)) {
            payload = params;
        } else {
            // Try to cast to number
            const numericValue = Number(params);
            const isNumeric = !isNaN(numericValue);

            payload = {
                construction_site_id: isNumeric ? numericValue : params
            };
        }
        return axiosClient.post(url, payload);
    }
};